export enum SIBASI_APPS {
  MONIVAL = 'MONIVAL',
  EBMSUITE = 'EBMSUITE',
  EBOARD = 'EBOARD'
}

export enum SIBASI_SYSTEM_APP_MODULES {
  GENERAL = 'GENERAL',
  USER = 'USER',
  TEST = 'TEST',
  MEETING = 'MEETING',
  ACTIONPOINT = 'ACTIONPOINT',
  USERPROFILEPICTURE = 'USERPROFILEPICTURE',
  ITEM = 'ITEM',
  ITEMCATEGORIES = 'ITEMCATEGORIES',
  ITEMIMAGES = 'ITEMIMAGES',
  ORGANIZATIONLOGO = 'ORGANIZATIONLOGO',
  ISSUES = 'ISSUES',
  ISSUETASKS = 'ISSUETASKS',
  PROJECT = 'PROJECT',
  PROJECTACTIVITY = 'PROJECTACTIVITY',
  PROJECTACTIVITYTASK = 'PROJECTACTIVITYTASK',
  PLAN = 'PLAN',
  KITCHEN = 'KITCHEN',
  SIBASIFILE = 'SIBASIFILE',
  NOTE = 'NOTE',
  ORGANIZATION = 'ORGANIZATION',
  ORGANIZATIONMEMBERS = 'ORGANIZATIONMEMBERS',
  FOLDER = 'FOLDER',
  TASK = 'TASK',
  CONTACT = 'CONTACT',

  EXPENSEITEM = 'EXPENSEITEM',
  ORGANIZATIONPAYMENTTERM = 'ORGANIZATIONPAYMENTTERM',
  ASSET = 'ASSET',
  DELIVERY = 'DELIVERY',
  TRANSACTION_PAYMENT_RECORD = 'TRANSACTION_PAYMENT_RECORD',
  MENUACCESS = 'MENUACCESS',
  TRANSACTION = 'TRANSACTION',
  ONLINESHOP_HERO = 'ONLINESHOP_HERO',
  ONLINESHOP_LOGO = 'ONLINESHOP_LOGO',
  ONLINESHOP_ABOUT = 'ONLINESHOP_ABOUT',
  MPESACERTIFICATE = 'MPESACERTIFICATE',
  DASHBOARD = 'DASHBOARD',
  SALES = 'SALES',
  POS = 'POS',
  INVOICES = 'INVOICES',
  QUOTES = 'QUOTES',
  ORDERS = 'ORDERS',
  CUSTOMERS = 'CUSTOMERS',
  LEADS = 'LEADS',
  INSURER = 'INSURER',
  REPORTS = 'REPORTS',
  KITCHENDISPLAY = 'KITCHENDISPLAY',
  EXPENDITURE = 'EXPENDITURE',
  EXPENSES = 'EXPENSES',
  EXPENSESCATEGORIES = 'EXPENSESCATEGORIES',
  VENDORS = 'VENDORS',
  SETTINGS = 'SETTINGS',
  MEMBERS = 'MEMBERS',
  MEMBERSINVITE = 'MEMBERSINVITE',
  USERVOICE = 'USERVOICE',
  CHATSUPPORT = 'CHATSUPPORT',
  FEEEDBACK = 'FEEEDBACK',
  TRANSACTION_PRINTOUTS = 'TRANSACTION_PRINTOUTS',
  WEBSITE_BUILDER = 'WEBSITE_BUILDER',
  PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
  USER_PERMISSIONS = 'USER_PERMISSIONS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  ASSETCATEGORIES = 'ASSETCATEGORIES',
  EMPLOYEE = 'EMPLOYEE',
  OPPORTUNITIES = 'OPPORTUNITIES'
}
